module.exports = __webpack_public_path__ + "media/images/henrik-stenson.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/henrik-stenson.jpg
// module id = 70
// module chunks = 0